var _defs, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.01,
    height: 73.01,
    viewBox: "0 0 73.01 73.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #c6c6c5;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: none;\r\n        stroke: #c6c6c5;\r\n        stroke-miterlimit: 10;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.92,54.5h6.94V37.12H44.7l.52-5.83H39.86V28c0-1.37.27-1.92,1.6-1.92h3.76V20H40.41c-5.16,0-7.49,2.28-7.49,6.63v4.64H29.3v5.9h3.62Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 37.26,
    cy: 37.26,
    r: 35.74
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIconShare);
export default __webpack_public_path__ + "static/media/facebook-icon-share.366674562ebe6f07c29c7e857f50aeaa.svg";
export { ForwardRef as ReactComponent };